// mutation 常量

// csv文件中读取到的全部导航信息
export const SET_MENU_ARR = 'SET_MENU_ARR'
// 当前导航
export const SET_CURRENT_MENU = 'SET_CURRENT_MENU'
// 当前位置
export const SET_CURRENT_POSITION = 'SET_CURRENT_POSITION'
// 查询条件
export const SET_QUERY_CONDITION = 'SET_QUERY_CONDITION'
// 条件文字
export const SET_CONDITION_DESC = 'SET_CONDITION_DESC'
// 指标描述
export const SET_MKEY_DESCRIPTION = 'SET_MKEY_DESCRIPTION'
// 报表请求路径
export const SET_REPORT_BASEURL = 'SET_REPORT_BASEURL'



// WEBPACK FOOTER //
// ./src/store/mutations-type.js